import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "flex-center flex-col"
};
const _hoisted_2 = {
  class: "flex-center"
};
import { SubstitutionTypeEnum } from "@/modules/match/enums";
import EntityLink from "@/modules/vue/components/EntityLink.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'SubstitutionIncident',
  props: {
    liveIncident: null
  },
  setup(__props) {
    const props = __props;
    const isIn = computed(() => {
      return props.liveIncident.incident.substitutionType === SubstitutionTypeEnum.IN;
    });
    return (_ctx, _cache) => {
      const _component_Icon = _resolveComponent("Icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(EntityLink, {
        entity: __props.liveIncident.incident.team,
        disabled: "",
        class: "mb-2"
      }, null, 8, ["entity"]), _createElementVNode("div", _hoisted_2, [_unref(isIn) ? (_openBlock(), _createBlock(_component_Icon, {
        key: 0,
        icon: _ctx.IconEnum.ArrowLeft,
        size: "2rem",
        class: "mx-2 text-green-600"
      }, null, 8, ["icon"])) : (_openBlock(), _createBlock(_component_Icon, {
        key: 1,
        icon: _ctx.IconEnum.ArrowRight,
        size: "2rem",
        class: "mx-2 text-red-600"
      }, null, 8, ["icon"])), _createTextVNode(" " + _toDisplayString(__props.liveIncident.incident.player.shortName), 1)])]);
    };
  }
});